import React, {memo} from 'react'
import cx from 'classnames'

/* Cosmos */
import Button from '@cosmos/button'

/* Utils */
import DataSet from '../../../../utils/DataSet'
import {yieldToMain} from '../../../../utils/performance'

/* Components */
import HbImageView from '../../../../components/HbImage/view/HbImageView'

/* Constants */
import {DAVINCI_EVENT_NAMES} from '../../../../modules/analytics/davinci/davinciConstants'
import {MODAL_IDS} from '../../../../modules/modal/modalConstants'

/* Actions */
import {actionCreators as productActionsCreators} from '../../../../redux/actions/productActions'
import {actionCreators as modalActionCreators} from '../../../../redux/actions/modalActions'

/* Styles */
import s from './key-features.scss'

const KeyFeatures = memo(({
  dispatch,
  sku,
  merchantId,
  merchantName,
  categoryName,
  categoryId,
  price,
  listingId,
  productId,
  techSpecs,
  energyClassBadge,
  pageTypeForDavinci
}) => {
  const handleDescriptionClick = async() => {
    dispatch(
      productActionsCreators.setDesktopTabs.trigger(0)
    ).then(() => {
      document.getElementById('techSpecs')?.scrollIntoViewIfNeeded({behavior: 'smooth'})
    })
    await yieldToMain()
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.LINK_CLICK, {
      page_type: pageTypeForDavinci,
      page_value: sku,
      location: 'buybox',
      text: 'Tüm Ürün Bilgileri',
      placement: 'button',
      position: '',
      url: ''
    })
  }

  const handleEnergyClassModal = async() => {
    await yieldToMain()
    if (!energyClassBadge?.imageUrl && !energyClassBadge?.receiptUrl) {
      return
    }
    await yieldToMain()
    dispatch(
      modalActionCreators.openModal(MODAL_IDS.ENERGY_CLASS)
    )
  }

  const renderEnergyClassBadge = () => {
    return (
      <div
        className={cx(s.keyFeaturesItem, s.energyClass)} onClick={() => handleEnergyClassModal()}
        data-hbus={DataSet.createComponentViewDataForDavinci({
          pageType: pageTypeForDavinci,
          pageValue: sku,
          placement: 'EnergyClass',
          component: 'EnergyClass',
          componentDetail: 'Enerji sınıfı ve Ürün fişi',
          categoryHierarchy: `${categoryId} - ${categoryName}`,
          position: 1,
          productId,
          merchantName,
          merchantId,
          listingId,
          price: `${price}`
        })}>
        <HbImageView
          className={s.image}
          image={{
            alt: energyClassBadge?.receiptText,
            src: energyClassBadge?.iconUrl,
            size: '60-40',
            componentSize: {
              width: 60,
              height: 40,
            },
            originSize: {
              width: 60,
              height: 40,
            },
          }}/>
        <div className={cx(s.content, s.energyClass)}>{energyClassBadge?.receiptText}</div>
      </div>
    )
  }

  return (
    <div
      className={s.root} data-test-id={'key-features'} data-hbus={
        DataSet.createComponentViewDataForDavinci({
          placement: 'buybox',
          component: 'Key Features',
          componentDetail: 'Ürün Bilgileri',
          pageType: pageTypeForDavinci,
          pageValue: sku,
          productId: productId,
          merchantName: merchantName,
          merchantId: merchantId,
          listingId: listingId || '',
          price: price?.toString() || ''
        })
      }>
      {
        techSpecs?.length > 0 &&
        <>
          <h2 className={s.staticTitle}>
            {'Ürün Bilgileri'}
          </h2>
          <div className={s.container}>
            <div className={s.container}>
              {energyClassBadge?.iconUrl && renderEnergyClassBadge()}
              {
                techSpecs?.map((item, index) => {
                  return (
                    <div className={s.keyFeaturesItem} key={index}>
                      <div className={s.title}>
                        {item?.name}
                      </div>
                      <div className={s.content}>
                        {item?.property}
                      </div>
                    </div>
                  )
                })
              }
            </div>
            <Button kind='ghost' size='small' className={s.button} onClick={() => handleDescriptionClick()}>
              <div className={s.icon}></div>
              <div>{'Tüm Ürün Bilgileri'}</div>
            </Button>
          </div>
        </>
      }
    </div>
  )
})

export default KeyFeatures
